<script>
import appConfig from "@/app.config";

import InvoicesListe from "@/components/invoices-list"

import CustomersApi from "@/services/customers-api";

export default {
  page: {
    title: "Liste des Factures",
    meta: [{ name: "description", content: appConfig.description }]
  },

  mounted(){
    this.role=sessionStorage.getItem("userr");
    if(this.role==1){
      this.getCustomers()
    }
    
    
  },

  components: {InvoicesListe},
  data() {
    return {
      role:null,
      selectedState:null,
      status:null,
      customersList:[],
      selectedCustomer:null,
      selected:null,
      start:null,
      end:null,
      exportInvoicesInProgress : false,
    };
  }, 
  methods:{
    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
        response => {
          this.customersList=response;
        }
      )
    },

    exportEXCEL(){
      this.exportInvoicesInProgress = true;
      this.$refs.invoicesList.exportInvoicesListExcel()
      .then(() => {
           this.exportInvoicesInProgress = false;
        })
      
    },

  },
    watch: {
        selected: function() {
            this.selectedCustomer = this.selected ? this.selected.id : null
        },

        selectedState: function() {
            this.status = this.selectedState ? this.selectedState.value : null
        },

        start: function(){
        },

        end: function(){
        }

    }       
    }

</script>

<style>
  .style-vselect .vs__search {
    line-height: 1;
    color: #394066;
    font-size: 1em
  }

</style>

<template>
  <div>

   
  <div class="row mt-2">
    <div class="col-sm-12 text-right" >
      <b-form-group label="_" class="text-white" label-for="">
        <b-button variant="success" @click.prevent="exportEXCEL()" :disabled="exportInvoicesInProgress">
          <b-spinner small :class="exportInvoicesInProgress ? 'mr-1' : 'd-none'"></b-spinner>
          <i class="fas fa-file-excel text-white font-size-16 m-0 p-0 font-weight-bold align-middle mr-2"></i> 
          <span class=" font-weight-bold text-white text-uppercase">{{$t('invoicesMenu.export')}} </span>
      </b-button>
      </b-form-group>
    </div>

  </div>

   <div  class="row mt-2">

          <div  v-if="role==1" class="col-md-3 col-xs-12 pr-md-4">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
              <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selected">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
              </v-select>
            </b-form-group>
          </div>

            <div class="col-md-3 col-xs-12 pr-md-4">
              <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"  label-for="">
                  <b-form-datepicker
                  v-model="start"
                  :locale="$t('datPicker.locale')"
                  :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                  dark
                  reset-button
                  close-button
                  :label-reset-button="$t('datPicker.label-reset-button')"
                  :label-close-button="$t('datPicker.label-close-button')"
                  dropright
                  hide-header
                  ></b-form-datepicker>
              </b-form-group>
            </div>
            <div class="col-md-3 col-xs-12 pr-md-4">
              <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')" label-for="">
                  <b-form-datepicker
                  v-model="end"
                  :locale="$t('datPicker.locale')"
                  :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                  dark
                  reset-button
                  close-button
                  :label-reset-button="$t('datPicker.label-reset-button')"
                  :label-close-button="$t('datPicker.label-close-button')"
                  dropright                         
                  hide-header
                  ></b-form-datepicker>
              </b-form-group>
            </div>

            <div v-if="role!=1" class="col-md-3 col-xs-12 pr-md-4" />

            <div class="col-md-3 col-xs-12">
              <b-form-group :label="$t('lists.status.filter')" label-for="">
                <v-select class="style-vselect" style="font-size:1.2em;" 
                :options="[{name :$t('invoiceState.status.unpaid'),value: 0},{name :$t('invoiceState.status.inprogress'), value: 1},
                           {name :$t('invoiceState.status.paid'), value: 2}]" 
                label="name" v-model="selectedState" :searchable="false" :placeholder="$t('lists.status.label')">
                  <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div>
        </div>

  
  <InvoicesListe ref="invoicesList" :status.sync=this.status :customerId.sync=this.selectedCustomer  :start.sync=start :end.sync=end />
    
  </div>
</template>